var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33308 0.333496H16.6664C18.0471 0.333496 19.1664 1.45278 19.1664 2.8335V3.18969C19.1665 3.19697 19.1665 3.20424 19.1664 3.21151V12.0002C19.1664 13.3809 18.0471 14.5002 16.6664 14.5002H3.33308C1.95237 14.5002 0.833079 13.3809 0.833079 12.0002V3.21148C0.832984 3.20423 0.832984 3.19698 0.833079 3.18972V2.8335C0.833079 1.45278 1.95237 0.333496 3.33308 0.333496ZM2.49975 4.80187V12.0002C2.49975 12.4604 2.87284 12.8335 3.33308 12.8335H16.6664C17.1266 12.8335 17.4997 12.4604 17.4997 12.0002V4.80187L11.4334 9.04831C10.5726 9.65087 9.42689 9.65087 8.56609 9.04831L2.49975 4.80187ZM17.4973 2.76916L10.4776 7.68293C10.1907 7.88378 9.80879 7.88378 9.52186 7.68293L2.50219 2.76916C2.53504 2.33899 2.89449 2.00016 3.33308 2.00016H16.6664C17.105 2.00016 17.4645 2.33899 17.4973 2.76916Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.fbcabaa49b4f173ae9f3de4b1c36ee1a.svg";
export { ForwardRef as ReactComponent };